/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Card_NextInputs */

const en_us2_wrapped_card_next = /** @type {(inputs: Wrapped_Card_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next card`)
};

const pt_br2_wrapped_card_next = /** @type {(inputs: Wrapped_Card_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo cartão`)
};

const es_419_wrapped_card_next = /** @type {(inputs: Wrapped_Card_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjeta siguiente`)
};

const pt_pt2_wrapped_card_next = /** @type {(inputs: Wrapped_Card_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartão seguinte`)
};

const fr_fr2_wrapped_card_next = /** @type {(inputs: Wrapped_Card_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte suivante`)
};

const de_de2_wrapped_card_next = /** @type {(inputs: Wrapped_Card_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Karte`)
};

const it_it2_wrapped_card_next = /** @type {(inputs: Wrapped_Card_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheda successiva`)
};

/**
* | output |
* | --- |
* | "Next card" |
*
* @param {Wrapped_Card_NextInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_card_next = /** @type {((inputs?: Wrapped_Card_NextInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Card_NextInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_card_next(inputs)
	if (locale === "es-419") return es_419_wrapped_card_next(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_card_next(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_card_next(inputs)
	if (locale === "de-DE") return de_de2_wrapped_card_next(inputs)
	if (locale === "it-IT") return it_it2_wrapped_card_next(inputs)
	return en_us2_wrapped_card_next(inputs)
});
export { wrapped_card_next as "wrapped.card_next" }